/** Cadenas de interfaz en español de Chile (es-CL). Única fuente de textos de la UI. */
export const strings = {
  appName: "FABIAN-MELI",
  appTagline: "AI Commerce OS",
  search: "Buscar productos, órdenes, clientes…",
  themeDark: "Tema oscuro",
  themeLight: "Tema claro",
  notifications: "Notificaciones",
  operator: "Operador",
  dashboard: {
    greeting: "Estado del negocio",
    systemHealth: "Salud del ecosistema",
    pendingDecisions: "Decisiones pendientes",
    recommendations: "Recomendaciones del cerebro",
    goals: "Metas",
    revenue: "Tendencia de ventas",
    engines: "Motores",
    approve: "Aprobar",
    review: "Revisar",
    confidence: "confianza",
    viewAll: "Ver todo",
    empty: "Sin elementos por ahora.",
  },
  engine: {
    activity: "Actividad reciente",
    export: "Exportar",
    newItem: "Nuevo",
  },
  states: {
    loading: "Cargando…",
    error: "No se pudo cargar la información.",
    retry: "Reintentar",
  },
  health: {
    healthy: "Saludable",
    degraded: "Degradado",
    critical: "Crítico",
  },
} as const;

export type Strings = typeof strings;
